import React, { useState, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Header.css';
import {useAppState} from "../../store/useAppState";

interface HeaderProps {
    onMenuClick: () => void;
    showBackButton?: boolean;
    stepIndex?: number;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick, showBackButton, stepIndex }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { isDrawerMenuOpen, changeDrawerMenuState } = useAppState();
    const [isBackButtonDisabled, setIsBackButtonDisabled] = useState(false);

    const handleBack = useCallback(() => {
        // Prevent multiple rapid clicks
        if (isBackButtonDisabled) {
            return;
        }

        // Disable the button temporarily
        setIsBackButtonDisabled(true);

        const currentPath = location.pathname;
        const match = currentPath.match(/\/quiz\/f(\w+)\/(\d+)\/v(\d+)/);
        if (match) {
            const funnelId = match[1];
            const currentStep = parseInt(match[2], 10);
            const currentVersion = match[3] || '1';
            if (currentStep > 1) {
                navigate(`/quiz/f${funnelId}/${currentStep - 1}/v${currentVersion}`);
            } else {
                navigate('/');
            }
        } else {
            navigate(-1);
        }

        // Re-enable the button after 800ms
        setTimeout(() => {
            setIsBackButtonDisabled(false);
        }, 800);
    }, [isBackButtonDisabled, location.pathname, navigate]);

    const isFirstStep = stepIndex === 1;

    return (
        <header className="header" style={isDrawerMenuOpen ? {display: 'none'}: { position:'fixed'}}>
            <div className="header__left">
                {!isFirstStep && (
                    <button
                        className={`header__back-button ${isBackButtonDisabled ? 'header__back-button--disabled' : ''}`}
                        onClick={handleBack}
                        disabled={isBackButtonDisabled}
                        aria-label="Go back"
                    >
                        <img
                            src="/images/arrow-left.png"
                            alt="Back"
                            width="24"
                            height="24"
                        />
                    </button>
                )}
            </div>
            <div className={`header__logo-container${!isFirstStep ? ' header__logo-container--with-back' : ''}${isFirstStep ? ' header__logo-container--left' : ''}`}>
                { isFirstStep  ? <img
                    src="/images/logo-full.png"
                    alt="Logo"
                    className="header__logo"
                /> : <img
                    src="/images/logo-single.png"
                    alt="Logo"
                    className="header__logo"
                />}
            </div>
            <div className="header__right">
                <button
                    className="header__menu-button"
                    onClick={() => changeDrawerMenuState(true)}
                    aria-label="Open menu"
                >
                   <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z" fill="currentColor"/>
                    </svg>
                </button>
            </div>
        </header>
    );
};

export default Header;
